import curry from "../../lib/core/functional/curry";

import { vote, getResults } from "../../transport/voting";

import { getUpDown } from "./templates";

const ON_VOTE_RESULTS = "updownvoting::results";
const VOTER_ID_KEY = "RM-poll";
const UPVOTE_BODY = { positive: 1, negative: 0 };
const DOWNVOTE_BODY = { positive: 0, negative: 1 };

function votingContextFactory(context, particle) {
    const upButton = particle.querySelector(".vote-up");
    const downButton = particle.querySelector(".vote-down");
    const postId = particle.dataset.postId;
    return {
        particle,
        upButton,
        downButton,
        postId,
        vote: {},
        siteId: context.settings.site.id,
        particleId: particle.dataset.id,
        postContextElement: document.querySelector(`#post-context-${postId}`),
        upNumbers: upButton.querySelector(".number"),
        downNumbers: downButton.querySelector(".number"),
    };
}

function setVoterId(voter_id) {
    localStorage.setItem(VOTER_ID_KEY, JSON.stringify({ voter_id }));
}

function getVoterId() {
    const voterInfo = localStorage.getItem(VOTER_ID_KEY);
    return voterInfo ? JSON.parse(voterInfo).voter_id : null;
}

function disableButton(button) {
    button.classList.add("disabled");
    button.disabled = true;
}

function enableButton(button) {
    button.classList.remove("disabled");
    button.disabled = false;
}

function highlightButton(button) {
    button.classList.add("voted");
}

function showResult({ reactions }, { particleId, upNumbers, downNumbers }) {
    const { positive = { total: 0, count: 0 }, negative = { total: 0, count: 0 } } =
        reactions[particleId] || {};
    upNumbers.textContent = `${positive.total}`;
    downNumbers.textContent = `${negative.total}`;
}

function toggleEnabled({ reactions }, { particleId, upButton, downButton }) {
    const { positive = 0, negative = 0 } = reactions[particleId] || {};

    if (positive || negative) {
        disableButton(upButton);
        disableButton(downButton);

        if (positive) {
            highlightButton(upButton);
        } else {
            highlightButton(downButton);
        }
    }
}

const onVoteResults = curry(function onVoteResults(votingContext, event) {
    const { poll, vote } = event.detail;
    votingContext.vote = vote;
    showResult(poll, votingContext);
    toggleEnabled(vote, votingContext);
});

const onVoteSuccess = curry(function onVoteSuccess(
    { upButton, downButton, postContextElement },
    serverPayload
) {
    setVoterId(serverPayload.vote.voter_id);

    postContextElement.dispatchEvent(
        new CustomEvent(ON_VOTE_RESULTS, {
            detail: serverPayload,
        })
    );
});

const onVoteError = curry(function ({ upButton, downButton }, _error) {
    enableButton(upButton);
    enableButton(downButton);
});

const doVote = curry(function doVote(votingContext, voteBody, event) {
    const body = {
        reactions: {
            ...votingContext.vote.reactions,
            [votingContext.particleId]: voteBody,
        },
        payload: {},
    };

    disableButton(votingContext.upButton);
    disableButton(votingContext.downButton);

    vote(votingContext.siteId, votingContext.postId, getVoterId(), body)
        .then(onVoteSuccess(votingContext))
        .catch(onVoteError(votingContext));
});

const activeFetches = {};

const onResultsSuccess = curry(function onResultsSuccess(
    { postId, postContextElement },
    serverPayload
) {
    activeFetches[postId] = false;
    postContextElement.dispatchEvent(
        new CustomEvent(ON_VOTE_RESULTS, {
            detail: serverPayload,
        })
    );
});

const onResultsError = curry(function onResultsError({ postId }, _error) {
    activeFetches[postId] = false;
});

function getVotes(votingContext) {
    if (activeFetches[votingContext.postId]) return;

    activeFetches[votingContext.postId] = true;
    getResults(votingContext.siteId, votingContext.postId, getVoterId())
        .then(onResultsSuccess(votingContext))
        .catch(onResultsError(votingContext));
}

const holder_selector = ".up_down_voting--wrp";

export default function assemblerUpDownVoting(context, element) {
    const upDownHolder = element.querySelector(holder_selector);
    if (!upDownHolder) return;
    upDownHolder.innerHTML = getUpDown();

    const votingContext = votingContextFactory(context, element);
    votingContext.postContextElement.addEventListener(
        ON_VOTE_RESULTS,
        onVoteResults(votingContext)
    );

    votingContext.upButton.addEventListener("click", doVote(votingContext, UPVOTE_BODY));
    votingContext.downButton.addEventListener("click", doVote(votingContext, DOWNVOTE_BODY));
    getVotes(votingContext);
}
